import type { CategoryInterface } from '@/types'
import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

export const APPROVAL_STATUSES = ['DRAFT', 'APPROVED', 'REJECTED'] as const

export type ApprovalStatus = (typeof APPROVAL_STATUSES)[number]

export const APPROVAL_STATUS_LABELS: Record<ApprovalStatus, string> = {
  APPROVED: 'Утверждена',
  DRAFT: 'На модерации',
  REJECTED: 'Отклонена',
}

export const CHARACTERISTIC_STATUS_LABELS: Record<ApprovalStatus, string> = {
  APPROVED: 'Утверждена',
  DRAFT: 'На модерации',
  REJECTED: 'Отклонена',
}

export const isApprovedStatus = (status?: string | null) =>
  !status || status === 'APPROVED'

export const isCatalogApprover = (roles?: string[] | null) =>
  hasRoleFromGroup(roles, 'CATALOG_APPROVERS')

export const getStatusBadge = (
  status?: string | null,
  labels: Record<ApprovalStatus, string> = APPROVAL_STATUS_LABELS
) => {
  if (isApprovedStatus(status)) return null

  const normalized = status as ApprovalStatus
  if (!APPROVAL_STATUSES.includes(normalized)) return null

  const className =
    normalized === 'REJECTED' ? 'approvalStatusRejected' : 'approvalStatusDraft'

  return <span className={className}>{labels[normalized]}</span>
}

export const getApprovalStatusLabel = (
  status?: string | null,
  labels: Record<ApprovalStatus, string> = APPROVAL_STATUS_LABELS
) => {
  if (isApprovedStatus(status)) return null

  const normalized = status as ApprovalStatus
  if (!APPROVAL_STATUSES.includes(normalized)) return null

  return labels[normalized]
}

export const filterApprovedCategoryTree = (
  tree: CategoryInterface[]
): CategoryInterface[] =>
  tree
    .filter((node) => isApprovedStatus(node.category.status))
    .map((node) => ({
      ...node,
      childCategories: filterApprovedCategoryTree(node.childCategories || []),
    }))
